export default "__VITE_ASSET__Bice1BVz__";